import { useState, useEffect } from "react";
import style from "./account.module.scss";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import ProgressBar from "../navBar/progressBar";
import DownloadProgressIcon from "../navBar/DownloadProgressIcon";
import {
  selectDownloadZipProgress,
  selectDownloadIDBProgress,
} from "../../features/counter/counterSlice";
import { IDB_KEY_LENGTH } from "../../constants/ccms";

const AccountProfile = ({ name, email, isEmailVisible }) => {
  const [downloadCompleted, setDownloadCompleted] = useState(false);
  // Use same Redux selectors as ModernNavbar for consistent progress display
  const progressIDBState = useSelector(selectDownloadIDBProgress);
  const progressZipState = useSelector(selectDownloadZipProgress);
  const iDB = useSelector((state) => state.counter.iDB);
  const progress = useSelector((state) => state.counter.downloadProgress);

  useEffect(() => {
    const fetchKeys = async () => {
      const iDBKeys = await iDB.keys();
      const downloadCompleted = iDBKeys.length > IDB_KEY_LENGTH;
      setDownloadCompleted(downloadCompleted);
    };
    fetchKeys();
    // IMPORTANT: progress dependency ensures we re-check IDB when progress updates
    // This allows "Available Offline" to appear immediately when IDB completes,
    // without requiring a page refresh
  }, [iDB, progress]);

  // isEmailVisible is true for individual users, false for institutions
  return (
    <div className={style.accountProfile}>
      <div className={style.logoContainer}>
        <img
          src="/TherapeuticGuidelines_Original_R_Logo.svg"
          className="account_tg_logo"
          alt="profile tg logo"
          width="160"
          height="60"
          border="0"
        ></img>
      </div>
      <div className={style.progressWrapper}>
        <div>
          {name && <p className={style.name}>{name}</p>}
          {isEmailVisible && email && <p className={style.email}>{email}</p>}
          {!name && !email && (
            <p className={style.noname}>Log in or subscribe to manage account details</p>
          )}
          <div className={style.progressContainer}>
            <DownloadProgressIcon zipProgress={progressZipState} idbProgress={progressIDBState} />
          </div>
          {downloadCompleted && (
            <div className={style.progressBarContainer}>
              <ProgressBar />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AccountProfile.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  isEmailVisible: PropTypes.bool,
};

export default AccountProfile;
